"use client";
import React from "react";
import DailyTaskCard from "../Components/DailyTaskCard";
import StockInOutCard from "../Components/StockInOutCard";
import ReminderCard from "../Components/ReminderCard";
import LiveLocationDemo from "../Components/LiveLocationDemo";
import RunningTrip from "../Components/RunningTrip";
import {demoTrips} from "../../../../data/demoData";
import Transactions from "../Components/Transactions";

export default function Home() {
    // const {
    //     layoutState,
    //     accessToken
    // } = useContext(LayoutContext);



    return (
       <div>
           {/*line 1 summary card*/}
           <div className="grid">
               <div className="col-12 md:col-6 xl:col-3">
                   <DailyTaskCard/>
               </div>
               <div className="col-12 md:col-6 xl:col-3">
                   <StockInOutCard/>
               </div>
               <div className="col-12 md:col-6 xl:col-3">
                   <DailyTaskCard/>
               </div>
               <div className="col-12 md:col-6 xl:col-3">
                   <ReminderCard/>
               </div>


               <div className="col-12 md:col-6 xl:col-3">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Total Trip</span>
                       <div className="flex justify-content-between align-items-start mt-3">
                           <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                               122
                            </span>
                               <div className="text-green-500">
                                   <span className="font-medium">+12%</span>
                                   <i className="pi pi-arrow-up text-xs ml-2"></i>
                               </div>
                           </div>
                           <div className="w-6">
                               <svg
                                   width="100%"
                                   viewBox="0 0 115 41"
                                   fill="none"
                                   xmlns="http://www.w3.org/2000/svg"
                               >
                                   <path
                                       d="M1 35.6498L2.24444 32.4319C3.48889 29.214 5.97778 22.7782 8.46667 20.3627C10.9556 17.9473 13.4444 19.5522 15.9333 21.7663C18.4222 23.9803 20.9111 26.8035 23.4 30.6606C25.8889 34.5176 28.3778 39.4085 30.8667 37.2137C33.3556 35.0189 35.8444 25.7383 38.3333 26.3765C40.8222 27.0146 43.3111 37.5714 45.8 38.9013C48.2889 40.2311 50.7778 32.3341 53.2667 31.692C55.7556 31.0499 58.2444 37.6628 60.7333 39.4617C63.2222 41.2607 65.7111 38.2458 68.2 34.9205C70.6889 31.5953 73.1778 27.9597 75.6667 23.5955C78.1556 19.2313 80.6444 14.1385 83.1333 13.8875C85.6222 13.6365 88.1111 18.2272 90.6 20.2425C93.0889 22.2578 95.5778 21.6977 98.0667 18.8159C100.556 15.9341 103.044 10.7306 105.533 7.37432C108.022 4.01806 110.511 2.50903 111.756 1.75451L113 1"
                                       style={{
                                           strokeWidth: "1px",
                                           stroke: "var(--primary-color)",
                                       }}
                                   />
                               </svg>
                           </div>
                       </div>
                   </div>
               </div>
               <div className="col-12 md:col-6 xl:col-3">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Revenue</span>
                       <div className="flex justify-content-between align-items-start mt-3">
                           <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                ৳ 607,500
                            </span>
                               <div className="text-green-500">
                                   <span className="font-medium">+20%</span>
                                   <i className="pi pi-arrow-up text-xs ml-2"></i>
                               </div>
                           </div>
                           <div className="w-6">
                               <svg
                                   width="100%"
                                   viewBox="0 0 115 41"
                                   fill="none"
                                   xmlns="http://www.w3.org/2000/svg"
                               >
                                   <path
                                       d="M1 35.6498L2.24444 32.4319C3.48889 29.214 5.97778 22.7782 8.46667 20.3627C10.9556 17.9473 13.4444 19.5522 15.9333 21.7663C18.4222 23.9803 20.9111 26.8035 23.4 30.6606C25.8889 34.5176 28.3778 39.4085 30.8667 37.2137C33.3556 35.0189 35.8444 25.7383 38.3333 26.3765C40.8222 27.0146 43.3111 37.5714 45.8 38.9013C48.2889 40.2311 50.7778 32.3341 53.2667 31.692C55.7556 31.0499 58.2444 37.6628 60.7333 39.4617C63.2222 41.2607 65.7111 38.2458 68.2 34.9205C70.6889 31.5953 73.1778 27.9597 75.6667 23.5955C78.1556 19.2313 80.6444 14.1385 83.1333 13.8875C85.6222 13.6365 88.1111 18.2272 90.6 20.2425C93.0889 22.2578 95.5778 21.6977 98.0667 18.8159C100.556 15.9341 103.044 10.7306 105.533 7.37432C108.022 4.01806 110.511 2.50903 111.756 1.75451L113 1"
                                       style={{
                                           strokeWidth: "1px",
                                           stroke: "var(--primary-color)",
                                       }}
                                   />
                               </svg>
                           </div>
                       </div>
                   </div>
               </div>
               <div className="col-12 md:col-6 xl:col-3">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Expense</span>
                       <div className="flex justify-content-between align-items-start mt-3">
                           <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                ৳ 385,500
                            </span>
                               <div className="text-pink-500">
                                   <span className="font-medium">+24%</span>
                                   <i className="pi pi-arrow-down text-xs ml-2"></i>
                               </div>
                           </div>
                           <div className="w-6">
                               <svg
                                   width="100%"
                                   viewBox="0 0 115 41"
                                   fill="none"
                                   xmlns="http://www.w3.org/2000/svg"
                               >
                                   <path
                                       d="M1.5 1L2.74444 2.61495C3.98889 4.2299 6.47778 7.4598 8.96667 9.07151C11.4556 10.6832 13.9444 10.6767 16.4333 11.6127C18.9222 12.5487 21.4111 14.4271 23.9 16.6724C26.3889 18.9178 28.8778 21.5301 31.3667 20.1977C33.8556 18.8652 36.3444 13.5878 38.8333 11.3638C41.3222 9.13969 43.8111 9.96891 46.3 11.9894C48.7889 14.0099 51.2778 17.2217 53.7667 16.2045C56.2556 15.1873 58.7444 9.9412 61.2333 11.2783C63.7222 12.6155 66.2111 20.5359 68.7 21.4684C71.1889 22.401 73.6778 16.3458 76.1667 16.0009C78.6556 15.6561 81.1444 21.0217 83.6333 24.2684C86.1222 27.515 88.6111 28.6428 91.1 27.4369C93.5889 26.2311 96.0778 22.6916 98.5667 22.7117C101.056 22.7317 103.544 26.3112 106.033 29.7859C108.522 33.2605 111.011 36.6302 112.256 38.3151L113.5 40"
                                       style={{
                                           strokeWidth: "1px",
                                           stroke: "var(--pink-500)",
                                       }}
                                   />
                               </svg>
                           </div>
                       </div>
                   </div>
               </div>
               <div className="col-12 md:col-6 xl:col-3">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Income</span>
                       <div className="flex justify-content-between align-items-start mt-3">
                           <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                ৳ 553,000
                            </span>
                               <div className="text-pink-500">
                                   <span className="font-medium">+24%</span>
                                   <i className="pi pi-arrow-down text-xs ml-2"></i>
                               </div>
                           </div>
                           <div className="w-6">
                               <svg
                                   width="100%"
                                   viewBox="0 0 115 41"
                                   fill="none"
                                   xmlns="http://www.w3.org/2000/svg"
                               >
                                   <path
                                       d="M1.5 1L2.74444 2.61495C3.98889 4.2299 6.47778 7.4598 8.96667 9.07151C11.4556 10.6832 13.9444 10.6767 16.4333 11.6127C18.9222 12.5487 21.4111 14.4271 23.9 16.6724C26.3889 18.9178 28.8778 21.5301 31.3667 20.1977C33.8556 18.8652 36.3444 13.5878 38.8333 11.3638C41.3222 9.13969 43.8111 9.96891 46.3 11.9894C48.7889 14.0099 51.2778 17.2217 53.7667 16.2045C56.2556 15.1873 58.7444 9.9412 61.2333 11.2783C63.7222 12.6155 66.2111 20.5359 68.7 21.4684C71.1889 22.401 73.6778 16.3458 76.1667 16.0009C78.6556 15.6561 81.1444 21.0217 83.6333 24.2684C86.1222 27.515 88.6111 28.6428 91.1 27.4369C93.5889 26.2311 96.0778 22.6916 98.5667 22.7117C101.056 22.7317 103.544 26.3112 106.033 29.7859C108.522 33.2605 111.011 36.6302 112.256 38.3151L113.5 40"
                                       style={{
                                           strokeWidth: "1px",
                                           stroke: "var(--pink-500)",
                                       }}
                                   />
                               </svg>
                           </div>
                       </div>
                   </div>
               </div>


               <div className="col-12 md:col-6 ">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Last Transections</span>
                       {/*<RunningTrip trips={demoTrips}/>*/}
                       <Transactions/>
                   </div>
               </div>
               <div className="col-12 md:col-6 ">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Current Location</span>
                       {/*<RunningTrip trips={demoTrips}/>*/}
                       <LiveLocationDemo/>
                   </div>
               </div>

               <div className="col-12 ">
                   <div className="card h-full">
                       <span className="font-semibold text-lg">Running Trip</span>
                       <RunningTrip trips={demoTrips}/>
                   </div>
               </div>
           </div>
       </div>
    );
}
